export const isDemo = () => {
  const url = window.location.href;
  return url.includes('demo');
};

export const isNotDemo = () => {
  const url = window.location.href;
  return !url.includes('demo');
};
